export default {
  tabs: {
    marjorShareHolders: 'MAJOR SHAREHOLDERS',
    boardOfDirectors: 'BOARD OF DIRECTORS',
  },

  listTitleTableMajorShareHolders: {
    NAME: 'NAME',
    SHARES: 'SHARES',
    PERCENTAGE: 'PERCENTAGE',
    PUBLIC_DATE: 'PUBLIC DATE',
  },

  listTitleTableBOD: {
    NAME: 'NAME',
    POSITION: 'POSITION',
    SHARES: 'SHARES',
    PERCENTAGE: 'PERCENTAGE',
    PUBLIC_DATE: 'PUBLIC DATE',
  },

  listTitleTooltipShareHolder: {
    COMPANY: 'COMPANY',
    SHARES: 'SHARES',
    PERCENTAGE: 'PERCENTAGE',
    PUBLIC_DATE: 'PUBLIC DATE',
  },

  listTitleTooltipBoD: {
    AN_DATE: 'START DATE',
    TYPE: 'TYPE',
    REGISTER: 'REGISTER',
    RESULT: 'RESULT',
    SHARE_BEFORE: 'SHARE',
    SHARE_AFTER: 'SHARE',
    PERCENTAGE: 'PERCENTAGE',
  },

  titleTooltip: {
    fiveLastestTransaction: '5 Lastest Transactions',
    investmentPortfolio: 'Investment Portfolio',
  },

  multiLineTitleTable: {
    BEFOR: '(BEFORE)',
    AFTER: '(AFTER)',
  },

  noData: 'No Data',

  titleChart: {
    overview: 'OVERVIEW',
    marjorOwnership: 'MAJOR OWNERSHIPS',
  },

  tooltipBODType: {
    buy: 'Buy',
    sell: 'Sell',
  },
};
